export default "__VITE_ASSET__4c783732__"